import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const SidebarWrapper = styled(Box)({
  display: "grid",
  gridTemplateColumns: "32px auto 16px",
  gridTemplateRows: "auto",
})

export const Header = styled(Typography)({
  display: "flex",
  padding: "12px 0px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
  color: "var(--brand-text-default)",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "28px",
})

export const InnerWrapper = styled(Box)({
  gridColumnStart: 2,
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  marginBottom: "20px",
})

export const StyledFieldLabel = styled(Typography)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
  border: "0",
  fontSize: "12px",
  color: "var(--grey-grey-06)",
}))

export const StyledFieldValue = styled(Typography)(({  }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
  border: "0",
  fontSize: "16px",
  whiteSpace: "pre-line",
}))